import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const selectTriggerDefaultVariants = {
  "menuOpen": false
}
const selectTriggerCompoundVariants = []

const selectTriggerSlotNames = [
  [
    "trigger",
    "SelectTrigger__trigger"
  ],
  [
    "leading",
    "SelectTrigger__leading"
  ],
  [
    "label",
    "SelectTrigger__label"
  ],
  [
    "caret",
    "SelectTrigger__caret"
  ]
]
const selectTriggerSlotFns = /* @__PURE__ */ selectTriggerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, selectTriggerDefaultVariants, getSlotCompoundVariant(selectTriggerCompoundVariants, slotName))])

const selectTriggerFn = memo((props = {}) => {
  return Object.fromEntries(selectTriggerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const selectTriggerVariantKeys = [
  "menuOpen"
]
const getVariantProps = (variants) => ({ ...selectTriggerDefaultVariants, ...compact(variants) })

export const selectTrigger = /* @__PURE__ */ Object.assign(selectTriggerFn, {
  __recipe__: false,
  __name__: 'selectTrigger',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: selectTriggerVariantKeys,
  variantMap: {
  "menuOpen": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, selectTriggerVariantKeys)
  },
  getVariantProps
})